module.exports = __webpack_public_path__ + "static/img/instruction-icon.e89e1281.png";